import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import { CurrencyPropType } from '../../../prop-types/currency';
import messages from './messages';
import FormattedCurrency from '../../../components/formatted-currency';
import { getInsuranceProviderById } from '../../../enums/insurance-providers';
import { RateRecommendationBanner } from './rate-recommendation-banner';

import style from './rate-recommendation.module.less';
import { RecommendedInsuranceProviderName } from './recommended-insurance-provider-name';

export const InsuranceProviderRateRecommendation = ({
  insuranceProviderId,
  rateDifference,
  onApply,
  onDismiss,
  className,
  theme = 'light',
}) => {
  const insuranceProvider = getInsuranceProviderById(insuranceProviderId);
  if (!insuranceProvider) {
    return null;
  }

  return (
    <RateRecommendationBanner
      applyButton={
        <Button className={style['rate-comparison-apply-button']} onClick={onApply} theme='white'>
          <FormattedMessage {...messages.recommendationApplyButton} />
        </Button>
      }
      bannerText={
        <Text
          formattedMessageValues={{
            insuranceProviderName: <RecommendedInsuranceProviderName insuranceProviderName={insuranceProvider.name} />,
            s: (chunks) => <strong>{chunks}</strong>,
            savings: () => (
              <strong>
                <FormattedCurrency currencyCode={rateDifference.code} value={rateDifference.value} />
              </strong>
            ),
          }}
          textType={TextType.Paragraph}
          value={messages.insuranceRecommendation}
        />
      }
      className={className}
      contentClassName={style['single-recommendation-banner-content']}
      onDismiss={onDismiss}
      theme={theme}
    />
  );
};

InsuranceProviderRateRecommendation.propTypes = {
  insuranceProviderId: PropTypes.string.isRequired,
  rateDifference: CurrencyPropType.isRequired,
  onApply: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  className: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
};
